import { Suspense } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import store from "redux/store";

import Loader from "component/Loader/index";

import Pages from "pages/index";
import "./App.css";
import { BrowserRouter as Router } from 'react-router-dom';

const App = () => {
  return (
    <Provider store={store}>
      <ChakraProvider>
        <Suspense fallback={<Loader />}>
          <Router>
            <Pages />
          </Router>
        </Suspense>
      </ChakraProvider>
    </Provider>
  );
};

export default App;
